'use client'

import { useUserContext } from '@/context'
import { canCreateTeams } from '@/features/permissions'
import { useRouter } from '@/navigation'

export function useCreateTeamAction() {
  const { team, organizationScope, authorization } = useUserContext()
  const router = useRouter()

  // Solo selection also covers accounts with no accepted workspace yet.
  const isSoloWorkspace =
    team?.status === 'SOLO' ||
    (organizationScope.isSolo &&
      Boolean(organizationScope.workspaceOrganizationId))
  const canCreateTeam = canCreateTeams(authorization)

  const handleCreateTeam = () => {
    void router.push('/team/new')
  }

  return { handleCreateTeam, canCreateTeam, isSoloWorkspace }
}
